import { SignInScreen } from "@/app/modules/User";

export const SignIn = () => {
  return <SignInScreen />;
};
